export default __webpack_public_path__ + "static/Metropolis-BoldItalic-964b7afe7408726cf23e1578b033f73d.woff2";